<template lang="pug">
UiStack(spacing="sm")
  UiStack(spacing="xs")
    UiBadge(
      size="xs"
      :variant="item.status === 'error' ? 'danger' : 'primary'"
    ) {{ item.status }}
    UiTooltip(v-if="item.status === 'error'")
      | {{ item.message[0] }} <br /> {{ $t("companies.reports.show_details") }}
      template(#activator)
        UiBadge.cursor-pointer(
          size="xs"
          variant="danger"
          @click="$emit('show')"
        ) !
  UiStack(
    spacing="xs"
    v-if="['uploaded', 'error'].includes(item.sftp_status)"
  )
    UiBadge(
      size="xs"
      :variant="item.sftp_status === 'uploaded' ? 'primary' : 'danger'"
    ) sftp
    UiTooltip
      | {{ item.sftp_message }}
      template(#activator)
        UiBadge.cursor-pointer(
          size="xs"
          :variant="item.sftp_status === 'uploaded' ? 'primary' : 'danger'"
          @click="$emit('show')"
        ) !
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  emits: ["show"],

  props: {
    item: {
      type: Object,
    },
  },

  computed: {},
});
</script>
